import styled from "styled-components";
import { getTheme } from "Theme";

const theme = getTheme();

export const RowBase = styled.tr`
  padding: 6px;
  margin: 1px 0 2px 0;
  align-items: center;
  font-size: 12px;
  background-color: ${(props) =>
    props.highlight
      ? props.highlight
      : props.odd
        ? theme.TABLE_ROW_ALT
        : theme.TABLE_ROW};
  cursor: ${(props) => props.clickable && "pointer"};
  :hover {
    background-color: ${theme.MAIN_COLOR};
  }
`;